import type { ExportPageStats } from "@/domain/export/computeExportStats";

export function ExportStatStrip({ stats }: { stats: ExportPageStats }) {
  const cells = [
    { n: stats.total, l: "Total exports" },
    { n: stats.running, l: "Running" },
    { n: stats.ready, l: "Ready" },
    { n: stats.failed, l: "Failed" },
  ];

  return (
    <div className="stat-strip">
      {cells.map((c) => (
        <div key={c.l} className="s">
          <span className="n tabular-nums">{c.n}</span>
          <span className="l">{c.l}</span>
        </div>
      ))}
    </div>
  );
}
